<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Download">
  <!-- pdf -->
  <div class="card p-0 rounded">
    <div class="card-details-div">
      <img
        [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
      <div class="card-body d-flex flex-column justify-content-between">
        <p class="text-start font-size-14 title-text">{{ worksheetItem.Title }}</p>

        <div class="btn btn-download rounded mx-auto" (click)="getDownload(worksheetId, worksheetItem.Id)" target="_blank">
          <span class="font-size-14 text-start header-title text-white text-capitalize fw-bolder">
            <span class="font-size-14 text-start header-title text-white text-capitalize">{{
              'gallery.download' | translate
            }}</span></span
          >
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Gallery">
  <!-- image -->
  <div class="card border-0 p-0 gallery">
    <div (click)="openGalleryImage(galleryImage)" class="cursor-pointer gallery-image-wrapper">
      <img
        [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
      <div class="gallery-link-overlay" *ngIf="worksheetItem.Title.trim()">
        <p class="gallery-link-title">{{ worksheetItem.Title }}</p>
      </div>
    </div>
  </div>
  <ng-template #galleryImage let-modal>
    <div class="gallery-modal" role="dialog" aria-modal="true" [attr.aria-label]="worksheetItem.Title">
      <div class="gallery-modal-stage">
        <button type="button" class="gallery-modal-close" [attr.aria-label]="'gallery.close' | translate" (click)="modal.dismiss()">
          <span class="icon material-icons" aria-hidden="true">cancel</span>
        </button>
        <div class="modal-gallery-card">
          <div class="modal-gallery-image">
            <img [src]="worksheetItem.Image | contentImage: '1' : 'marketplace'" [alt]="worksheetItem.Title" [@zoomAnimation] />
          </div>
          <div class="modal-gallery-footer" *ngIf="worksheetItem.Title.trim()">
            <p class="modal-gallery-title">{{ worksheetItem.Title }}</p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.ProviderVideo">
  <!-- video -->
  <div class="card border-0 p-0 rounded">
    <div [ngSwitch]="worksheetItem.ProviderId">
      <ng-container *ngSwitchCase="providerName.Facebook">
        <fgb-facebook-player [streamKey]="worksheetItem.ProviderKey"></fgb-facebook-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.YouTube">
        <fgb-youtube-player [streamKey]="worksheetItem.ProviderKey" [isPlaying]="isPlaying" [muted]="muted"></fgb-youtube-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.StreamingVideoProvider">
        <fgb-svp-player [streamKey]="worksheetItem.ProviderKey"></fgb-svp-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Twitch">
        <fgb-twitch-player [streamKey]="worksheetItem.ProviderKey"></fgb-twitch-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Viemo">
        <fgb-vimeo-player [streamKey]="worksheetItem.ProviderKey"></fgb-vimeo-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Boxcast">
        <fgb-boxcast-player [streamKey]="worksheetItem.ProviderKey"></fgb-boxcast-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Streamable">
        <fgb-streamable-player [streamKey]="worksheetItem.ProviderKey"></fgb-streamable-player>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Link">
  <ng-container *ngIf="galleryMode; else defaultLink">
    <!-- gallery link card -->
    <a [href]="worksheetItem.LinkUrl" target="_blank" class="gallery-link-card">
      <img
        [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
      <div class="gallery-link-overlay" *ngIf="worksheetItem.Title.trim()">
        <p class="gallery-link-title">{{ worksheetItem.Title }}</p>
      </div>
    </a>
  </ng-container>
  <ng-template #defaultLink>
    <!-- default link -->
    <div class="card border-0 p-0 link-worksheet">
      <div class="card-details-div">
        <img
          class="worksheet-link-img"
          [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
          [alt]="worksheetItem.Title"
          [useDefault]="true"
          [loyaltyType]="'marketplace'"
          draggable="false"
        />
      </div>
      <a target="_blank" [href]="worksheetItem.LinkUrl" class="btn btn-primary bg-primary text-description border-0 fw-bold">
        {{ worksheetItem.Description }}
      </a>
    </div>
  </ng-template>
</ng-container>
